import { useEffect, useMemo, useRef } from "react";

import { cartService } from "@/services";
import { useAppSelector } from "@/store/hooks";

const CART_SYNC_DEBOUNCE_MS = 180;

export const CartSyncBridge = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const items = useAppSelector((state) => state.cart.items);
  const itemsKey = useMemo(
    () =>
      JSON.stringify(
        items.map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
        })),
      ),
    [items],
  );
  const lastSyncedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      lastSyncedKeyRef.current = null;
      return;
    }

    if (lastSyncedKeyRef.current === itemsKey) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      void cartService
        .syncGuestCart(items)
        .then(() => {
          lastSyncedKeyRef.current = itemsKey;
        })
        .catch(() => {
          lastSyncedKeyRef.current = null;
        });
    }, CART_SYNC_DEBOUNCE_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isAuthenticated, items, itemsKey]);

  return null;
};
